import { jmrSquaredAttribution } from '../config/attribution';
import { demoPreview } from '../config/demo-preview';
import { business, siteConfig } from '../config/site';

export function JmrSquaredAttribution() {
  return (
    <footer
      className="u-defer border-t border-[color:var(--color-border)] bg-[color:var(--ink-900)] px-[var(--gutter)] pb-28 pt-14 lg:pb-14"
      aria-label="Website attribution"
    >
      <div className="u-shell flex flex-col gap-10">
        <p className="u-display max-w-[18ch] text-[clamp(1.5rem,4vw,2.75rem)] text-[color:var(--steel-600)]">
          {siteConfig.appName}
        </p>

        <p className="u-measure text-base text-[color:var(--steel-500)]">
          {demoPreview.attributionContext}
        </p>

        <div className="u-rule grid gap-6 pt-8 text-base text-[color:var(--steel-400)] sm:grid-cols-2 lg:grid-cols-3">
          <p>
            <span className="u-label block text-[color:var(--steel-500)]">
              {jmrSquaredAttribution.creditLabel}
            </span>
            <a
              href={jmrSquaredAttribution.studioUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex min-h-[44px] items-end border-b border-[color:var(--ink-500)] pb-0.5 text-[color:var(--bone-100)] transition-colors hover:border-[color:var(--signal-500)] hover:text-[color:var(--signal-400)]"
              style={{ transitionDuration: 'var(--t-state)', transitionTimingFunction: 'var(--e-settle)' }}
            >
              {jmrSquaredAttribution.studioName} · tech.jmrsquared.com
            </a>
          </p>

          <p>
            <span className="u-label block text-[color:var(--steel-500)]">
              {jmrSquaredAttribution.similarSiteMessage}
            </span>
            <a
              href={jmrSquaredAttribution.contactMailto}
              className="mt-2 inline-flex min-h-[44px] items-end border-b border-[color:var(--ink-500)] pb-0.5 text-[color:var(--bone-100)] transition-colors hover:border-[color:var(--signal-500)] hover:text-[color:var(--signal-400)]"
              style={{ transitionDuration: 'var(--t-state)', transitionTimingFunction: 'var(--e-settle)' }}
            >
              {jmrSquaredAttribution.contactEmail}
            </a>
          </p>

          <p>
            <span className="u-label block text-[color:var(--steel-500)]">Reach the business</span>
            <a
              href={business.telephoneHref}
              className="mt-2 inline-flex min-h-[44px] items-end border-b border-[color:var(--ink-500)] pb-0.5 text-[color:var(--bone-100)] transition-colors hover:border-[color:var(--signal-500)] hover:text-[color:var(--signal-400)]"
              style={{ transitionDuration: 'var(--t-state)', transitionTimingFunction: 'var(--e-settle)' }}
            >
              {business.telephoneDisplay}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
